import React, { useState } from 'react'
import { AdminPanelPage } from '../AdminPanelPage'
import { Button, Heading, Input } from '@aidkitorg/component-library'
import { DashboardBuilderPanel } from './components/DashboardBuilderPanel'
import { useLocalizedStrings } from '../../Localization'
import { useDashboards } from '../../Contexts/DashboardsContext'

export const DashboardBuilderPage = () => {
  const L = useLocalizedStrings();

  const { stagedComponents, stagedComponentsWithResults, createDashboard } = useDashboards()
  const [title, setTitle] = useState('My Dashboard')
  const [description, setDescription] = useState('A customizable dashboard for data visualization')
  const [isEditingHeader, setIsEditingHeader] = useState(false)

  const Header = () => {
    const [tempTitle, setTempTitle] =useState(title)
    const [tempDescription, setTempDescription] = useState(description)

    return (
      <div className="w-full flex justify-between">
        <div>
          {!isEditingHeader && (<>
            <Heading level="h1" className="m-0">{title}</Heading>
            <div className="inline-block text-lg text-gray-700">
              {description}
            </div>
          </>)}
          {isEditingHeader && (
            <div className="flex flex-col gap-y-2">
              <Input
                className="text-5xl font-bold"
                label="Dashboard Title"
                showLabel={false} 
                value={tempTitle} 
                onChange={(e) => setTempTitle(e.target.value)}
              />
              <Input
                className="text-lg"
                label="Dashboard Description"
                showLabel={false} 
                value={tempDescription} 
                onChange={(e) => setTempDescription(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className="flex items-center gap-2">
          {!isEditingHeader && (
            <>
              <Button variant="secondary" onClick={() => setIsEditingHeader(true)}>Edit</Button>
              <Button variant="primary" onClick={() => {
                createDashboard(title, description, stagedComponents)
              }}>Save Dashboard</Button>
            </>
          )}
          {isEditingHeader && (
            <>
              <Button variant="secondary" onClick={() => {
                setTempTitle(title)
                setTempDescription(description)
                setIsEditingHeader(false)
              }}>Cancel</Button>
              <Button variant="primary" onClick={() => {
                setTitle(tempTitle)
                setDescription(tempDescription)
                setIsEditingHeader(false)
              }}>Save Changes</Button>
            </>
          )}
        </div>
      </div>
    )
  }

  const pageActionButtons = [
    <Button variant="primary" onClick={() => {
      createDashboard(title, description, stagedComponents)
    }}>
      Save Dashboard
    </Button>
  ]
  
  // TODO: add modal and report selection, for now, just build from an empty page
  
  return (
    <AdminPanelPage
      title={L.admin_panel.dashboards.dashboards}
      description={"A customizable dashboard for data visualization"}
      pageActionButtons={pageActionButtons}
    >
      <div className="flex gap-4 h-full">
        <div className="flex-1">
          {
            stagedComponentsWithResults.map((component, idx) => {
              // TODO: i18n this
              const componentTitle = typeof component.title === 'string' ? component.title : component.title['en']

              return (
                <div className="border" key={idx}>
                  <div>
                    Title: {componentTitle}
                  </div>
                  <div>
                    Kind: {component.kind}
                  </div>
                  <div>
                    Value: {JSON.stringify(component.rows[0])}
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className="w-64 h-full border rounded-md bg-white">
          <DashboardBuilderPanel/>
        </div>
      </div>
    </AdminPanelPage>
  )
}